import { useTranslations } from 'next-intl';
import { buildRoute } from '@headless-workspace/config';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ProductLoyaltyInfoValue } from '../../../../server';
import { ProductDetailInfoModal } from '../../productDetails';
import { PushLoyaltyModalContent } from './PushLoyaltyModalContent';

type PushLoyaltyModalProps = PropsWithLocale & {
    loyaltyInformation: ProductLoyaltyInfoValue;
    currency: string;
    isVipBrand: boolean;
    hasBackCta?: boolean;
    isMySephoraActivated: boolean;
};

export const PushLoyaltyModal: Component<PushLoyaltyModalProps> = ({
    loyaltyInformation,
    currency,
    isVipBrand,
    hasBackCta,
    isMySephoraActivated,
    locale,
}) => {
    const t = useTranslations('Discover.Pdp.loyalty');
    const modalT = useTranslations('Modal.pushLoyalty.mySephora.label');
    const commonT = useTranslations('Common');

    const texts = isMySephoraActivated
        ? {
              title: modalT('programName'),
              closeButton: commonT('action.label.close'),
              actionButton: commonT('action.label.moreInformation'),
          }
        : {
              title: t('label.modalTitle'),
              closeButton: t('action.loyaltyAlreadyMember'),
              actionButton: t('action.joinLoyaltyProgram'),
          };

    const loyaltyPointsLabel = t('label.loyaltyPoints', {
        value: loyaltyInformation.pointsToEarn,
    });

    return (
        <ProductDetailInfoModal
            title={texts.title}
            closeButtonLabel={texts.closeButton}
            actionButtonLabel={texts.actionButton}
            actionButtonHref={buildRoute(locale, 'loyalty')}
            renderInformation={
                <PushLoyaltyModalContent
                    loyaltyPointsPerCurrency={loyaltyInformation.pointsPerCurrency}
                    loyaltyPointsLabel={loyaltyPointsLabel}
                    locale={locale}
                    currency={currency}
                    isVipBrand={isVipBrand}
                    isMySephoraActivated={isMySephoraActivated}
                />
            }
            hasBackCta={hasBackCta}
        />
    );
};
